import { notification } from 'antd';
import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { styled } from 'styled-components';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
const USER_NAME = process.env.REACT_APP_USER_NAME;
const PASSWORD = process.env.REACT_APP_PASSWORD;

const LoginForm = () => {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [showPassword, setShowPassword] = useState(false);

    const navigate = useNavigate();
    const [api, contextHolder] = notification.useNotification();

    const openNotification = ({ type, message, description }) => {
        api[type]({
            message,
            description,
            placement: 'bottomRight',
        });
    }

    const submitHandler = async (e) => {
        e.preventDefault();
        const details = {
            'user_email': email,
            'user_password': password,
        };

        var formBody = [];
        for (var property in details) {
        var encodedKey = encodeURIComponent(property);
        var encodedValue = encodeURIComponent(details[property]);
        formBody.push(encodedKey + "=" + encodedValue);
        }
        formBody = formBody.join("&");

        try {
            const response = await fetch(`${API_BASE_URL}/login`, {
                method: 'POST',
                headers: { 
                    'Authorization': 'Basic ' + btoa(`${USER_NAME}:${PASSWORD}`),
                    'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
                },
                body: formBody
            });
            const responseData = await response.json();

            if(responseData.code === 200) {
                localStorage.setItem('IS_LOGGED_IN', true);
                openNotification(
                    { 
                        type: 'success',
                        message: 'Welcome!', 
                        description: responseData.message,
                    }
                );
                setTimeout(() => {
                    navigate('dashboard');
                }, 1500);
            } else {
                openNotification(
                    { 
                        type: 'error',
                        message: 'Failed to Login!', 
                        description: responseData.message,
                    }
                );
            }
        } catch (error) {
            openNotification(
                    { 
                        type: 'error',
                        message: 'Failed to Login!', 
                        // description: error,
                    }
                );
        }  
    }

    return (
        <Container>
            <Wrapper>
                {contextHolder}
                <div className='login-header'>Login</div>
                <form onSubmit={submitHandler}>
                    <div className='input-group'>
                        <label for='email' >Enter Email ID:</label>
                        <input
                            onChange={(e) => setEmail(e.target.value)}
                            value={email}
                            className='input' 
                            placeholder='email' 
                            id='email' 
                            type='email' 
                        />
                    </div>
                    <div className='input-group'>
                        <label for='password' >Enter Password:</label>
                        <input 
                            onChange={(e) => setPassword(e.target.value)}
                            value={password}
                            className='input' 
                            placeholder='password' 
                            id='password' 
                            type={showPassword ? 'text' : 'password'} 
                        />
                        <div className='password-helper'>
                            <Link to='/forgot-password' className='forgot-password-link' >Forgot Password?</Link>
                            <div className='show-password'>
                                <input 
                                    type='checkbox' 
                                    value={showPassword} 
                                    onChange={(e) => setShowPassword(e.target.checked)} 
                                />
                                <span>Show Password</span>
                            </div>
                            
                        </div>
                    </div>
                    <div className='input-group'>
                        <button type='submit' className='login-btn'>Login</button>
                        {/* <p>New user? <Link className='main-text'>Signup</Link></p> */}
                    </div>
                </form>
            </Wrapper>
        </Container>
    );
}

export default LoginForm;

const Container = styled.div`
    background-image: linear-gradient(180deg, #73C2FB, #F2FAFF);
    width: 100vw;
    height: 100vh;
    position: absolute;
    top: 0;
    left: 0;
`;

const Wrapper = styled.div`
    box-shadow: 0 1px 3px rgba(0,0,0,0.12), 0 1px 2px rgba(0,0,0,0.24);
    background-color: #F2FAFF;
    border-radius: 0 0 0.2rem 0.2rem;
    width: 35%;
    margin: auto;
    margin-top: 12rem;
    padding-bottom: 2rem;
    animation: zoom-pop 300ms ease-out forwards;

    .login-header {
        height: 5rem;
        background-color: ${({theme}) => theme.colors.primary};
        // border: 2px solid ${({theme}) => theme.colors.primary};
        border-radius: 0.2rem 0.2rem 0 0;
        color: #fff;
        font-size: 3rem;
        letter-spacing: 0.25rem;
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .input-group {
        display: flex;
        gap: 1.5rem;
        flex-direction: column;
        width: 80%;
        margin: 4rem auto;
        label {
            font-size: 1.5rem;
            color: ${({theme}) => theme.colors.primary};
        } 
        input {
            height: 3rem;
            padding: 2rem;
            font-size: 1.8rem;
            border: 1.5px solid #ccc;
            border-radius: 0.2rem;
        }
        input:focus {
            background-color: #def2ff;
            border: 1.5px solid ${({theme}) => theme.colors.primary};
            border-radius: 0.2rem;
        }
        p {
            text-align: center;
        }
        .main-text {
            color: ${({theme}) => theme.colors.primary};
        }
        .password-helper {
            display: flex;
            justify-content: space-between;
            align-items: center;
            .show-password {
                display: flex;
                align-items: center;
                gap: 1rem;
            }
            span {
                font-size: 1.5rem;
                color: #36454F;
            }
            .forgot-password-link {
                font-size: 1.5rem;
                width: max-content;
                color: #ff6b6b;
            }
        }
    }
    
    .login-btn {
        background-color: #10ac84;
        border: none;
        color: #fff;
        font-size: 2rem;
        padding: 1rem;
        cursor: pointer;
        margin-top: 1rem;
        border-radius: 0.2rem;
        text-align: center;
        letter-spacing: 0.0625rem;
        &:hover {
            transform: translateY(-2px);
            box-shadow: 5px 5px 5px #ccc;
        }
        &:active {
            transform: translateY(0);
            box-shadow: 3px 3px 3px #ccc;
        }
    }
`;

